module.exports = require('./lib/eql');



/*****************
 ** WEBPACK FOOTER
 ** ./~/deep-eql/index.js
 ** module id = 140
 ** module chunks = 1
 **/